import { ReactNode } from "react";
import { IconChevronRight } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

export interface UsageMetric {
  label: string;
  value: number;
}

interface ProductUsageSummaryCardProps {
  /** Used for the aria-label; the visible cell shows `icon` instead. */
  label: string;
  icon: ReactNode;
  metrics: UsageMetric[];
  onViewList: () => void;
}

const ProductUsageSummaryCard = ({
  label,
  icon,
  metrics,
  onViewList,
}: ProductUsageSummaryCardProps) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={onViewList}
      aria-label={`${label} — ${t("productEditor.productUsageViewList")}`}
      className="flex w-full items-center gap-3 rounded-md border border-yellow-200 bg-white/50 p-3 text-left transition-colors hover:border-yellow-300 hover:bg-yellow-100/60"
    >
      <span className="shrink-0">{icon}</span>
      <span className="flex-1 border-l border-yellow-200 pl-3 text-sm text-yellow-800">
        {metrics.map((metric, index) => (
          <span key={metric.label}>
            {index > 0 ? " · " : ""}
            <span className="font-semibold text-yellow-900">
              {metric.value}
            </span>{" "}
            {metric.label}
          </span>
        ))}
      </span>
      <IconChevronRight
        className="h-5 w-5 shrink-0 text-yellow-700"
        stroke={2}
      />
    </button>
  );
};

export default ProductUsageSummaryCard;
